
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface TeacherSalaryFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  confirmationStatusFilter: string;
  onConfirmationStatusFilterChange: (value: string) => void;
  onClearFilters: () => void;
}

export function TeacherSalaryFilters({
  searchQuery,
  onSearchChange,
  confirmationStatusFilter,
  onConfirmationStatusFilterChange,
  onClearFilters
}: TeacherSalaryFiltersProps) {
  const hasActiveFilters = searchQuery || confirmationStatusFilter !== 'all';

  return (
    <div className="flex gap-4 items-center mb-4 p-4 bg-gray-50 rounded-lg">
      <div className="flex-1">
        <Input
          placeholder="ค้นหาชื่อครู หรือ รหัสครู..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="max-w-sm"
        />
      </div>
      
      <Select
        value={confirmationStatusFilter}
        onValueChange={onConfirmationStatusFilterChange}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="สถานะยืนยัน" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">สถานะยืนยันทั้งหมด</SelectItem>
          <SelectItem value="ACCEPTED">ยืนยันแล้ว</SelectItem>
          <SelectItem value="WAITING">รอยืนยัน</SelectItem>
          <SelectItem value="DECLINED">ปฏิเสธ</SelectItem>
        </SelectContent>
      </Select>

      {hasActiveFilters && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClearFilters}
          className="flex items-center gap-2"
        >
          <X className="h-4 w-4" />
          ล้างตัวกรอง
        </Button>
      )}
    </div>
  );
}
